import { render } from "./super-users.vue?vue&type=template&id=1a934822&lang=html"
import script from "./super-users.vue?vue&type=script&lang=js"
export * from "./super-users.vue?vue&type=script&lang=js"

import "./super-users.vue?vue&type=style&index=0&id=1a934822&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__